module.exports = __webpack_public_path__ + "img/chapter_practice.2fc86fd6.svg";